import React from "react";
import {Fab, makeStyles, useTheme} from "@material-ui/core";
import {Delete} from "@material-ui/icons";
import clsx from "clsx";

const useStyle = makeStyles(theme => {
    const offset = theme.spacing(2)
    return {
        root: {
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            position: "relative",
            "& .MuiFab-root": {
                position: "absolute",
                bottom: offset,
                right: offset
            }
        }
    }
})

class DisposableImage extends React.Component{
    constructor(props){
        super(props)
        const {width, height} = props
        this.image = new Image()
        if (width === undefined || height === undefined) {
            this.state = {
                width: 0,
                aspect: 0
            }
            this.image.addEventListener('load', () => {
                const aspect = this.image.height / this.image.width
                this.setState({
                    width: width || (height && height / aspect) || this.image.width,
                    aspect: aspect
                })
            })
        }
        else{
            this.state = {
                width: width,
                aspect: height / width
            }
        }
        this.image.src = props.src
        this.delete = e => {
            e.stopPropagation()
            if (window.confirm('Are you sure?')) {
                this.props.onDelete()
            }
        }
        this.ref = React.createRef()
    }

    componentDidMount() {
        this.setState({
            width: this.ref.current.clientWidth
        })
    }


    render() {
        const {aspect} = this.state
        const {width, height, onDelete, style, src, ...props} = this.props
        if (!aspect) {
            return <div ref={this.ref}/>
        }
        return <div
            ref={this.ref}
            style={{
                height: this.state.width * aspect,
                backgroundImage: `url(${this.image.src})`,
                ...style
            }}
            {...props}
        >
            <Fab color={this.props.color} size="small" onClick={this.delete}>
                <Delete/>
            </Fab>
        </div>
    }
}

export default function({onDelete, className, width, height, color, ...props}){
    const classes = useStyle(useTheme())
    return <DisposableImage
        className={clsx(classes.root, className)}
        onDelete={onDelete}
        width={width}
        height={height}
        color={color}
        {...props}
    />
}
